/* eslint-disable import/no-default-export */
export default () => [
  { id: 1, description: 'Full time' },
  { id: 2, description: 'Part time' },
  { id: 3, description: 'Contract' },
  { id: 4, description: 'Casual' },
];
